/**
 * India timezone identifiers (IANA)
 */
const INDIA_TIMEZONES = ['Asia/Kolkata', 'Asia/Calcutta'];

/**
 * Detect if the user is in India based on their timezone
 * @returns {boolean}
 */
export const isIndiaTimezone = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return INDIA_TIMEZONES.includes(tz);
  } catch {
    return false;
  }
};

/**
 * Self-paced price in INR for India
 */
export const SELF_PACED_INR = 8499;
